export default __webpack_public_path__ + "static/media/save.7c8ea6fb.svg";